//Enavi Custom Gold Buyer
window.theme = window.theme || {};

theme.EnaviGoldBuyer = (function() {

  const selectors = {
    weightInput: 'input.gold-weight',
    karatSelect: 'select.karat-sel',
    calculateButton: '.estimate-btn',
    resultDiv: '.gold-price-value',
  };

  function EnaviGoldBuyer(container) {
    if(container){
      this.container = container; 
      this.init();
    }
  };

  EnaviGoldBuyer.prototype = Object.assign({}, EnaviGoldBuyer.prototype, {
    init: function() {
      this.weightInput = this.select(selectors.weightInput);
      this.karatSelect = this.select(selectors.karatSelect);
      this.calculateButton = this.select(selectors.calculateButton);
      this.resultDiv = this.select(selectors.resultDiv);

      if (!window.goldBasePrice) {
        this.fetchGoldPrice();
      }

      this.addEventListeners();
    },  

    select: function(selector){
      return this.container.querySelector(selector);
    },

    addEventListeners: function(){
      this.calculateButton && this.calculateButton.addEventListener('click', function(event) {
        event.preventDefault();
        const basePrice = window.goldBasePrice;

        if (!basePrice) {
          this.fetchGoldPrice().then(function() {
            this.calculatePrice(window.goldBasePrice);
          }.bind(this)).catch(function(error) {
            console.error("Error fetching gold price:", error);
          });
        } else {
          this.calculatePrice(basePrice);
        }

      }.bind(this));
    },
    
    fetchGoldPrice: function() {
      return new Promise(function(resolve, reject) {
        fetch("https://app.lirysjewelers.com/init/getCurrentBasePrice.php")
          .then(response => response.json())
          .then(data => {
            window.goldBasePrice = parseFloat(data.gold.goldPrice);
            resolve(window.goldBasePrice);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    calculatePrice: function(basePrice){
      const weight = parseFloat(this.weightInput.value);
      const karat = parseInt(this.karatSelect.value);

      // Calculate the gold price for the selected karat
      const purity = karat / 24;
      const price = (basePrice * purity * 0.8 * weight).toFixed(2);

      // Display the calculated price
      this.resultDiv.innerHTML = `Estimated gold value: <strong>$${price}</strong>`;
      
    }
    
  });

  return EnaviGoldBuyer;
})();

new theme.EnaviGoldBuyer(document.querySelector('.section-custom-gold-buyer'));